import { takeLatest, all, call, put } from 'redux-saga/effects';

import EmailIntegrationsActions from '../actions';
import EmailIntegrationsApi from '../email-integrations-api';

function* fetchNotificationListHandler({ payload: { experienceId, accountId } }) {
  try {
    const response = yield call(EmailIntegrationsApi.fetchNotificationList, experienceId, accountId);
    yield put(EmailIntegrationsActions.fetchNotificationListSuccess(response));
  } catch (error) {
    yield put(EmailIntegrationsActions.fetchNotificationListFailure(error));
  }
}

function* removeNotificationHandler({ payload: { emailTemplateId } }) {
  try {
    yield call(EmailIntegrationsApi.removeNotification, emailTemplateId);
    yield put(EmailIntegrationsActions.removeNotificationSuccess(emailTemplateId));
  } catch (error) {
    yield put(EmailIntegrationsActions.removeNotificationFail(error));
  }
}

function* disableNotificationHandler({ payload: { emailTemplateId } }) {
  try {
    const response = yield call(EmailIntegrationsApi.disableNotification, emailTemplateId);
    yield put(EmailIntegrationsActions.updateNotificationStatusFromList(response));
  } catch (error) {
    yield put(EmailIntegrationsActions.disableNotificationFail(error));
  }
}

function* enableNotificationHandler({ payload: { emailTemplateId } }) {
  try {
    const response = yield call(EmailIntegrationsApi.enableNotification, emailTemplateId);
    yield put(EmailIntegrationsActions.updateNotificationStatusFromList(response));
  } catch (error) {
    yield put(EmailIntegrationsActions.enableNotificationFail(error));
  }
}

export default function* notificationListSaga() {
  yield all([
    takeLatest(EmailIntegrationsActions.removeNotification.getType(), removeNotificationHandler),
    takeLatest(EmailIntegrationsActions.fetchNotificationList.getType(), fetchNotificationListHandler),
    takeLatest(EmailIntegrationsActions.disableNotification.getType(), disableNotificationHandler),
    takeLatest(EmailIntegrationsActions.enableNotification.getType(), enableNotificationHandler),
  ]);
}
